// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2Vb3p","dragIcon":"Choice_dragIcon__3nMBv","left":"Choice_left__1fe95","input":"Choice_input__4QO3Q"};